import dayjs from 'dayjs'
import React from 'react'
import { PlateFilter } from '~/api/backend/pages/culturesPageAPI'
import CloseIcon from '~/components/icons/CloseIcon'
import { CultureStatusText } from '~/pages/cultures/FilterBar/CultureStatusText'
import { snakeCaseToTitleCase } from '~/utils/string'
import cs from './filter_pill.scss'
import PlateStatusText from './PlateStatusText'

function FilterPill({
  filter,
  onDeleteClick,
}: {
  filter: PlateFilter
  onDeleteClick: () => void
}) {
  let tokens: React.ReactNode[] = []

  const formatDatetime = (datetime: string) => {
    return dayjs(datetime).format('YYYY-MM-DD, HH:mmA')
  }

  // TODO(nate): Refactor this to make it cleaner
  if (filter.field === 'plate_status') {
    if (filter.operator && filter.operator.values) {
      if (filter.operator.values.length === 1) {
        tokens = [
          snakeCaseToTitleCase(filter.field),
          'is',
          <PlateStatusText status={filter.operator.values[0]} />,
        ]
      } else if (filter.operator.values.length === 2) {
        tokens = [
          snakeCaseToTitleCase(filter.field),
          'is any of',
          <div className={cs.multiOptionToken}>
            {filter.operator.values.map((value, index) => (
              <>
                <PlateStatusText status={value} key={index} />
                {index !== filter.operator.values.length - 1 && (
                  <div className={cs.separator}>,</div>
                )}
              </>
            ))}
          </div>,
        ]
      } else {
        return null
      }
    } else {
      return null
    }
  }

  if (filter.field === 'culture_status') {
    if (filter.operator && filter.operator.values) {
      if (filter.operator.values.length === 1) {
        tokens = [
          snakeCaseToTitleCase(filter.field),
          'is',
          <CultureStatusText status={filter.operator.values[0]} />,
        ]
      } else if (filter.operator.values.length >= 2) {
        tokens = [
          snakeCaseToTitleCase(filter.field),
          'is any of',
          <div className={cs.multiOptionToken}>
            {filter.operator.values.map((value, index) => (
              <React.Fragment key={value}>
                <CultureStatusText status={value} />
                {index !== filter.operator.values.length - 1 && (
                  <div className={cs.separator}>,</div>
                )}
              </React.Fragment>
            ))}
          </div>,
        ]
      } else {
        return null
      }
    } else {
      return null
    }
  }

  if (
    filter.field === 'first_checked_in_at' ||
    filter.field === 'last_checked_out_at' ||
    filter.field === 'last_generated_at'
  ) {
    if (
      filter.operator &&
      filter.operator.operator_type === 'is_between_datetime_range'
    ) {
      if (filter.operator.lower_datetime && filter.operator.upper_datetime) {
        tokens = [
          snakeCaseToTitleCase(filter.field),
          'is between',
          formatDatetime(filter.operator.lower_datetime),
          'and',
          formatDatetime(filter.operator.upper_datetime),
        ]
      } else if (filter.operator.lower_datetime) {
        tokens = [
          snakeCaseToTitleCase(filter.field),
          'is after',
          formatDatetime(filter.operator.lower_datetime),
        ]
      } else if (filter.operator.upper_datetime) {
        tokens = [
          snakeCaseToTitleCase(filter.field),
          'is before',
          formatDatetime(filter.operator.upper_datetime),
        ]
      } else {
        return null
      }
    } else {
      return null
    }
  }

  return (
    <div className={cs.filterPill}>
      {tokens.map((token, index) => (
        <div className={cs.token} key={index}>
          {token}
        </div>
      ))}
      <div className={cs.iconContainer} onClick={onDeleteClick}>
        <CloseIcon className={cs.icon} onClick={() => {}} />
      </div>
    </div>
  )
}

export default FilterPill
